var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer mg-top-20"},[_vm._v("\n        "+_vm._s(_vm.footsystem.name)+"  @技术支持  中微信通 "),_c('br'),_vm._v("\n        联系人电话："+_vm._s(_vm.footsystem.tel)+"  邮编：1000035"),_c('br'),_vm._v("\n        "+_vm._s(_vm.footsystem.bah)+"  公安网安备110112119号\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83d6dc34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myFoot.vue
// module id = null
// module chunks = 